import { render, staticRenderFns } from "./nodeStat.vue?vue&type=template&id=fafeb73c&scoped=true&"
import script from "./nodeStat.vue?vue&type=script&lang=js&"
export * from "./nodeStat.vue?vue&type=script&lang=js&"
import style0 from "./nodeStat.vue?vue&type=style&index=0&id=fafeb73c&scoped=true&lang=css&"
import style1 from "./nodeStat.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fafeb73c",
  null
  
)

export default component.exports